export default __webpack_public_path__ + "static/media/decrease_tendency.f97ab773.svg";